export default __webpack_public_path__ + "3e7e6addcdedc6aba97417c859b65a90.png";